import React from 'react'
import './video.css';

interface Props {
    src : string;
}

export class Video extends React.Component<Props> {

    render() {
        return (
            <div className="video-container">
                <video className="video" controls>
                  <source src={ this.props.src } type="video/mp4"/>
                  Your browser does not support the video tag.
                </video>
            </div>
        );
    }
}

